module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjcAAABGBAMAAADC56jQAAAAGFBMVEUAAACOjo6VlZWTk5OUlJSUlJSUlJSUlJR8FnxdAAAAB3RSTlMACUhJkdvc7YzvQwAAAN5JREFUeNrt2SEOwgAQRFEKAssRegSOxvVxSEDsiMnKt6r6ZZLfppeLG+/4Pt5fOP7ufWUw3w/OSWPGedKwnArHzTiYAs4NhuVUOA8YM46Sw5HybRxKAUfJLafDUfKAI1ZwpHwbR6wCjgXB6XCUPOCIFRwp38ZR8oBjQHA6HCUPOGIFR8q3cZQ84NgPnA5HyQOOWMGR8m0cJQ845gOnw1HygHNygANnGefAMON4zYHj82Edx2dnwBErOBWOkgccsYIj5es4Sh5wxApOhaPkAUes4Ej5Oo6Sw+lw/LQa7wNmewaZybuaKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/juxing-hui.png
// module id = 1F5b
// module chunks = 70